<template lang="pug">
Page(titleType="custom")
  template(slot="header-title")
    .header-title-left
      span {{ $t('Integration.pageHeader_LogoWMS') }}

  template(slot="content-center")
    TableView(
      :data="LogoWMSStoreGroupList"
      :fields="fields"
      :readOnly="true"
      :componentName="'LogoWMSStoreGroupTable'"
    )
    portal(to="isActive")
      div(slot-scope="row")
        span {{row.isActive ? $t('Global_V2.active') : $t('Global_V2.not_active')}}


</template>

<script>

import { mapGetters, mapActions } from 'vuex'


export default {
  name: 'LogoWMS',

  async created () {
    this.getStoreGroupList()
  },

  computed: {
    ...mapGetters('LogoWMS', ['LogoWMSStoreGroupList']),


    fields () {
      return [
        {
          name: 'storeGroupName',
          is_visible: true,
          no_tooltip: true,
          short_title: this.$t('Dictionary.StoreGroup'),
          title: this.$t('Dictionary.StoreGroup')
        },
        {
          name: 'isActive',
          is_visible: true,
          type: 'portal',
          short_title: this.$t('Integration.licenseStatus'),
          title: this.$t('Integration.licenseStatus')
        }
      ]
    }
  },
  methods: {
    ...mapActions('LogoWMS', ['getLogoWMSStoreGroupList']),
  

    getStoreGroupList (search) {
      this.getLogoWMSStoreGroupList({integrationProductId: this.$route.params.id})
    }
  }
}
</script>